import type { ColumnSort, OnChangeFn, SortingState } from "@tanstack/react-table"
import { getCoreRowModel } from "@tanstack/react-table"
import type { FC, Ref } from "react"

import { usePaymentTermColumns } from "../hooks/usePaymentTermColumns"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { PaymentTerm } from "@/graphql/codegen/graphql"

interface PaymentTermTableProps {
  data: PaymentTerm[]
  fetching: boolean
  scrollHandler: () => void
  tableContainerRef?: Ref<HTMLDivElement>
  onSortingChange: OnChangeFn<SortingState>
  sorting: ColumnSort[]
  error?: Error
}

const PaymentTermTable: FC<PaymentTermTableProps> = ({
  data,
  error,
  scrollHandler,
  onSortingChange,
  sorting,
  tableContainerRef,
  fetching,
}) => {
  const columns = usePaymentTermColumns()

  return (
    <AerosBaseTable<PaymentTerm>
      error={error}
      features={{
        table: {
          stickyHeader: true,
        },
        tanstackOptions: {
          data,
          columns,
          state: {
            sorting,
            isLoading: fetching,
          },
          manualSorting: true,
          enableSorting: true,
          enableMultiSort: false,
          enableSortingRemoval: false,
          getCoreRowModel: getCoreRowModel(),
          onSortingChange,
        },
      }}
      slotProps={{
        container: {
          ref: tableContainerRef,
          onScroll: scrollHandler,
        },
        bodyRow: {
          className: "hover:bg-primary-100 cursor-pointer",
        },
      }}
      noDataMessage='No payment term found'
    />
  )
}

export default PaymentTermTable
